<template>
  <basic-container>
    <div class="factoring-contract-detail">
      <div class="inner-con">
        <div class="project-title">
          {{ basicInfoData.projectName }}
        </div>
        <div class="project-status">
          <CommonDetail
            :configArray="formConfig"
            :initValue="basicInfoData"
            :showNull="false"
          />
          <div class="status_wrapper">
            <div class="status-title">归还状态</div>
            <div
              class="status-content"
              :class="['stateTopdiv', 'color_' + basicInfoData.isPayment]"
            >
              {{ basicInfoData.paymentStr }}
            </div>
          </div>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane class="activelabel" label="计息列表" name="first">
            <div class="informationxm">
              <div class="form_wrapper">
                <div class="form_header">
                  <div class="form_header_name">数据列表</div>
                  <div class="form_header_remarks">
                    共产生费用: <span>{{ interestAmount }} </span> 元
                    ;宽限期使用费<span>{{ interestAmountKxj }} </span>元,
                    逾期使用费<span>{{ interestAmountYq }} </span>元
                  </div>
                </div>
                <div class="form_content">
                  <avue-crud
                    :option="tableConfig"
                    :data="dataList"
                    v-model="tableForm"
                    :page.sync="page"
                  >
                  </avue-crud>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </basic-container>
</template>
<script>
import { overdueDetailConfig, overdueDetailListConfig } from "./config.js";
import InfoContainer from "@/components/infoContainer/infoContainer";
import * as api from "@/api/factoring/factoringScheme";
import CommonDetail from "./commonDetail";
import { floatAdd } from "@/util/util";
export default {
  name: "overdueDetail",

  data() {
    return {
      activeName: "first",
      formConfig: overdueDetailConfig(this.getMoney),
      tableConfig: overdueDetailListConfig(this.getMoney),
      basicInfoData: {},
      detail: {},
      InfoContainerConfig: {
        infoTitle: "数据列表",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
      dataList: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      tableForm: {},
      interestAmount: "",
      interestAmountKxj: "",
      interestAmountYq: "",
    };
  },
  components: {
    InfoContainer,
    CommonDetail,
  },

  watch: {},
  async mounted() {
    this.id = this.$route.params.id;
    let res = await this.queryDetail(this.id);
    res.days =
      res.overdueDays + "+" + (res.expireDays ? res.expireDays : "0");
    this.basicInfoData = res;
    this.getDetailList();
  },
  methods: {
    queryDetail(id) {
      return new Promise(async (resolve, reject) => {
        let res = await api.getOverdueinterestDetail({ id: id });
        if (res.data.code == 200) {
          resolve(res.data.data);
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      });
    },
    async getDetailList() {
      let res = await api.getBloverdueinterestrecordList({
        overdueInterestId: this.id,
        size:-1
      });
      if (res.data.code == 200) {
        this.dataList = res.data.data.records;
        let interestAmount = 0,
          interestAmountKxj = 0,
          interestAmountYq = 0;

        this.dataList.map((item) => {
          if (item.isOverdue == 1) {
            interestAmountYq =floatAdd(interestAmountYq,Number(item.interestAmount));
          } else if (item.isOverdue == 0) {
            interestAmountKxj =floatAdd(interestAmountKxj,Number(item.interestAmount));
          }
        });
        interestAmount = interestAmountKxj + interestAmountYq;
        this.interestAmount = interestAmount;
        this.interestAmountYq = interestAmountYq;
        this.interestAmountKxj = interestAmountKxj;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.factoring-contract-detail {
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;
  .plan-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    i {
      margin-right: 5px;
      font-size: 14px;
    }
    .detail-button {
      font-size: 12px;
      color: #19be6b;
      cursor: pointer;
      margin-left: 15px;
    }
  }
  .inner-con {
    min-width: 1000px;
    max-width: 1100px;
    margin: 0 auto;
    margin-top: 3px;
    .project-name {
      // overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
    }
    .project-name:hover {
      color: #409eff;
      cursor: pointer;
    }
    .project-title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
    }
    .project-status {
      display: flex;
      .status_wrapper {
        width: 200px;
        .status-title {
          text-align: right;
          font-family: "微软雅黑", sans-serif;
          font-weight: 400;
          color: #999999;
          font-size: 14px;
        }
        .status-content {
          text-align: right;
          font-family: "微软雅黑", sans-serif;
          font-weight: 400;
          color: #666666;
          font-size: 20px;
          padding-top: 20px;
        }
      }
    }
  }
  .comment-container {
    margin-top: 20px;
    /deep/.detail-one {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    /deep/.comment-container {
      margin-top: 0 !important;
    }
  }
  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .color_0::before {
    background: #fec03d;
  }
  .color_1::before {
    background: #409eff;
  }
  .color_2::before {
    background: #51d351;
  }
  .color_3::before {
    background: #f56c6c;
  }
  .color_4::before {
    background: #f56c6c;
  }
}
/deep/.el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
/deep/.el-tabs__item.is-active {
  background: none;
}
/deep/.el-tabs__header {
  margin: 0px;
}
.form_wrapper {
  height: 100%;
  box-sizing: border-box;
  // border-width: 1px;
  // border-style: solid;
  // border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;
  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    border: 1px solid rgba(233, 233, 233, 1);
    background-color: rgba(249, 249, 249, 1);

    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: none;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #333333;
      font-size: 13px;
      font-weight: 700;
      span {
        color: #ff3b30;
        font-weight: 400;
      }
    }
  }

  .form_content_form {
    padding: 20px 50px;
    border: 1px solid #e2e2e2;
  }
}
/deep/ .avue-crud {
  width: 100%;
}
/deep/ .avue-crud__menu {
  display: none;
}
.informationxm {
  margin-top: 20px;
}
/deep/ .el-table th {
  background-color: #fff;
  // font-weight: 400;
}
/deep/ .el-table__footer-wrapper {
  /deep/ tbody {
    /deep/ td {
      color: #409eff;
    }
  }
}
</style>